//路由地址调整过，但需要兼容老的路由
export default {
    //消息的进入工作流页
    '/msg/wfapprove': '/msg/approveMenu',
    '/msg/wfnotice': '/msg/noticeList',
    '/msg/wftask': '/msg/taskList',
    '/msg/wfHistory': '/msg/historyList',
    //申请页
    '/allFlow': '/flow/initiateMenu',
    '/favFlow': '/flow/favMenu',
    '/inFlow': '/flow/mineList',
    '/flow/mine': '/flow/mineMenu',
    '/flow/wfminelist': '/flow/mineList',
    //申请页进入的审批Tab页
    '/flow/myapprove': '/flow/approveMenu',
    '/flow/wftask': '/flow/taskList',
    '/flow/wfhistory': '/flow/historyList',
    '/flow/wfnotice': '/flow/noticeList',
    //底部审批菜单进入
    '/wfapprove': '/wfApproveMenu',
    '/wftask': '/wfTaskList',
    '/wfhistory': '/wfHistoryList',
    '/wfnotice': '/wfNoticeList',
    //底部菜单直接进入
    '/wfapply': '/wfInitiateMenu',
    '/wfmine': '/wfMineMenu',
    '/wfminelist': '/wfMineList',
    '/wfmine/list': '/wfMineList',
}
